import React, { useState } from 'react';
import { SearchIcon } from '@panwds/icons';
import { Input } from '@panwds/react-ui';
import { useFilters } from '../../hooks/useFilters/useFilters.esm.js';

function InputSearchBarFilter(props) {
    var setFilters = useFilters().setFilters;
    var _a = useState(""), value = _a[0], setValue = _a[1];
    var onInputChange = function (event) {
        var _a;
        setValue(event.target.value);
        setFilters((_a = {},
            _a[props.name] = "".concat(event.target.value),
            _a));
    };
    return (React.createElement(Input, { key: "input_search_bar", prefix: React.createElement(SearchIcon, { size: "sm", className: "tw-text-gray-600 dark:tw-text-blue-steel-300" }), placeholder: "Search", addClassName: "tw-w-64 dark:tw-bg-blue-steel-900 dark:tw-border-blue-steel-800 tw-placeholder-gray-400 dark:tw-placeholder-blue-steel-400", disabled: props.disabled, value: value, onChange: onInputChange }));
}

export { InputSearchBarFilter };
//# sourceMappingURL=InputSearchBarFilter.esm.js.map
